// dedicated file for search, filter or related functions...
import { replaceAccentedCharacters } from './utils';

export const filterResults = (
  inputData,
  fields,
  queryStrings,
  isExact = false
) => {
  if (
    Array.isArray(inputData) &&
    Array.isArray(fields) &&
    Array.isArray(queryStrings)
  ) {
    const filteredResults = inputData.filter(elementData => {
      let isMatch = false;

      fields.forEach(field => {
        if (elementData[field]) {
          // @TODO next steps to supprt elementData[field] to be an array 👾
          const formattedField = replaceAccentedCharacters(
            elementData[field].trim()
          );
          queryStrings.forEach(queryString => {
            const formattedQueryString = replaceAccentedCharacters(
              queryString.trim()
            );
            if (isExact) {
              if (formattedField === formattedQueryString) {
                isMatch = true;
              }
            } else if (formattedField.includes(formattedQueryString)) {
              isMatch = true;
            }
          });
        }
      });
      return isMatch;
    });
    return filteredResults;
  } else {
    console.warn(
      'filter-functions.js -> getSearchResults received non valid arguments - inputData: ',
      inputData,
      ' fields: ',
      fields,
      ' queryStrings: ',
      queryStrings
    );
    return inputData;
  }
};

export const accumulatedFilterResults = (inputData, queryArray) => {
  if (Array.isArray(inputData) && Array.isArray(queryArray)) {
    let outputData = inputData;
    queryArray.forEach(({ fields, queryStrings, isExact }) => {
      outputData = filterResults(outputData, fields, queryStrings, isExact);
    });
    return outputData;
  } else {
    console.warn(
      'filter-functions.js -> accumulatedFilterResults received non valid arguments - inputData: ',
      inputData,
      ' queryArray: ',
      queryArray
    );
    return inputData;
  }
};
